/**
 * Testimonial Home
 */

export default function TestimonialHome() {
    const selectors = {
        'wrapper' : '.home-testimonials',
    };

    this.init = () => {
        this.photoswipe();
    };

    this.photoswipe = () => {
        jQuery(selectors.wrapper).find('.testimonial').on('click', function (event) {
            event.preventDefault();
            var __btn_click = jQuery(this);

            var _create_thumbnails = function ($pswpEl, $items, $gallery) {
                jQuery($pswpEl).find(".pswp__scroll-wrap").append('<div class="pswp__thumbnails"></div>');

                var __thumbnails = jQuery($pswpEl).find(".pswp__thumbnails");

                jQuery.each($items, function (index, item) {
                    __thumbnails.append('<div class="pswp__thumbnails-item"><img src="' + item.image_src + '" alt=""/></div>');
                });

                jQuery($pswpEl).find(".pswp__scroll-wrap").append(__thumbnails);


                jQuery($pswpEl).find(".pswp__thumbnails-item img").off("click").on('click', function (e) {
                    jQuery(".pswp__thumbnails-item img").removeClass("active");
                    jQuery(this).addClass("active");
                    $gallery.goTo(jQuery($pswpEl).find(".pswp__thumbnails-item img").index(jQuery(this)));
                });
            };

            var _openPhotoSwipe = function () {
                var pswpElement = document.querySelectorAll('.pswp')[0];

                // build items array
                var items = jQuery(".pswp-testimonials").data("testimonials")

                // define options (if needed)
                var __pswp_options = {
                    // history & focus options are disabled on CodePen
                    bgOpacity: 0.8,
                    history: false,
                    focus: false,
                    pinchToClose: false,
                    closeOnScroll: false,
                    closeOnVerticalDrag: false,

                };
                __pswp_options.index = __btn_click.parent().children().index(__btn_click);

                var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, __pswp_options);

                _create_thumbnails(pswpElement, items, gallery);

                // Gallery starts closing
                gallery.listen('close', function () {
                    jQuery(pswpElement).find(".pswp__thumbnails").remove();
                    jQuery(pswpElement).find(".video.container").remove();
                });

                gallery.listen('afterChange', function () {
                    console.log('afterChange')
                    jQuery(pswpElement).find(".pswp__thumbnails-item img").removeClass("active");
                    jQuery(pswpElement).find(".pswp__thumbnails img").eq(gallery.getCurrentIndex()).addClass("active");
                });

                gallery.init();

            };
            _openPhotoSwipe();

        });
    }
}
